/**
 * Create snapshot of first frame of gif
 */
import { workPool } from '@wochitnpm/helpers';

/** @namespace workPool.job.captureFirstFrame */
export default workPool.define(
  'captureFirstFrame',
  {
    getContext() {
      return {
        src: this.options.src,
      };
    },

    run() {
      const { src } = this.options;

      if (this.constructor._cache.has(src)) {
        const payload = this.constructor._cache.get(src);
        this.sleep(16).then(() => {
          this.$emit(payload);
          this.finish();
        });
      } else {
        this.captureFirstFrame().then(
          (payload) => {
            this.constructor._cache.set(src, payload);
            this.$emit(payload);
            this.finish();
          },
          () => {
            this.$emit({ error: true });
            this.abort();
          }
        );
      }
    },

    captureFirstFrame() {
      return new Promise((resolve, reject) => {
        const { src } = this.options;
        const image = document.createElement('IMG');
        image.crossOrigin = 'anonymous';

        image.addEventListener('error', () => {
          reject();
        });
        image.addEventListener('load', () => {
          const width = image.width;
          const height = image.height;

          const canvas = document.createElement('CANVAS');
          const context = canvas.getContext('2d');

          canvas.width = width;
          canvas.height = height;

          context.drawImage(image, 0, 0, width, height);
          const dataUrl = canvas.toDataURL('image/png');
          image.src = '';

          resolve({ dataUrl, width, height });
        });

        image.src = src;
      });
    },

    sleep(mSec) {
      return new Promise((resolve) => {
        setTimeout(resolve, mSec);
      });
    },
  },
  {
    _cache: new Map(),

    execute({ src }) {
      const isRunning = workPool.has({
        type: this.type,
        context: (jc) => jc.src === src,
      });

      if (!isRunning) {
        workPool.add(new this({ src }));
      }
    },

    applyFirstFrameImage({ image, dataUrl, width, height }) {
      image.src = dataUrl;
    },
  }
);
